<template lang="pug">
  .searchbox-container
    .column
      k-select.school.m-bottom-1(
        :preselectedOption='userInfo.schoolId'
        noSpacing
        :emptyOption='$t("shareResource.emptySchoolsSelect")'
        big name='user'
        keyName='value'
        labelName='label'
        :withBorder='false'
        :disabled='isTrial'
        @selectOption='searchBySchool'
        :options='schoolsOptions'
      )
      .row.middle.width-100
        .user-search-container.item-3.m-right-1
          input.input-base.user-search(
            type='text'
            @keypress.enter='filterUsers'
            autocomplet='off'
            name='memberSearch'
            v-model='search'
            :placeholder='$t("shareResource.searchPlaceholder")'
          )
        k-select.item-2.m-right-1(
          withBorder name='user'
          :options='levelsOptions'
          @selectOption='searchByLevel'
          :emptyOption='$t("shareResource.emptyLevelsOption")'
        )
        button.item-1.secondary-button(@click='filterUsers') {{ $t("shareResource.search") }}
</template>

<script>
import KSelect from '@/components/KSelect'
import { mapActions, mapState } from 'vuex'
import { i18n } from '@/main'
import userRole from '../mixins/userRole'

export default {
  mixins: [userRole],
  components: { KSelect },
  data() {
    return {
      search: '',
      educationalLevelsFilter: null,
      schoolId: null
    }
  },
  computed: {
    ...mapState({
      levels: state => state.profile.educationalLevels,
      userInfo: state => state.userInfo.userInfo,
      schools: state => state.profile.schoolsInSchoolGroup
    }),
    levelsOptions() {
      return this.levels.map(level => ({
        ...level,
        value: level.id,
        label: i18n.t(`educationalLevels.${level.name.toLowerCase()}`)
      }))
    },
    schoolsOptions() {
      return this.schools.map(sch => ({ ...sch, value: sch.id, label: sch.name }))
    }
  },
  async created() {
    await this.hydrateEducationalLevels()
    await this.hydrateSchoolsInSchoolGroup(this.userInfo.schoolGroupId)
    this.schoolId = this.userInfo.schoolId
  },
  methods: {
    ...mapActions([
      'hydrateSchoolsInSchoolGroup',
      'hydrateSchoolsInSchoolGroup',
      'hydrateEducationalLevels'
    ]),
    filterUsers() {
      this.$emit('search', {
        search: this.search,
        educationalLevels: this.educationalLevelsFilter,
        schoolId: this.schoolId
      })
    },
    searchByLevel(name, value) {
      this.educationalLevelsFilter = value
    },
    searchBySchool(name, value) {
      this.schoolId = value
      this.filterUsers()
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.loader{
  height: 500px;
  width: 100%;
}

.school{
  max-width: 350px;
  --font-size: 22px;
}

.user-search-container{
  position: relative;
  .user-search {
    border: 1px solid $gray;
    border-radius: 6px;
    margin: 0;
    margin-right: 10px;
    padding-left: 30px;
  }
  &::before {
    background: url('../assets/ic_search.svg');
    background-size: contain;
    content: '';
    height: 16px;
    width: 16px;
    position: absolute;
    top: 12px;
    left: 8px;
    opacity: 0.6;
  }
}
</style>
